import { Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PORTRAIT =
  "https://images.unsplash.com/photo-1579975979101-7a3c3909d659?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxtZW50b3IlMjB5b3V0aCUyMG1vdGl2YXRpb24lMjBwb3J0cmFpdCUyMGhpZ2glMjBjb250cmFzdHxlbnwwfHx8fDE3ODc0MTcwMTN8MA&ixlib=rb-4.1.0&q=85";

export const Founder = () => (
  <section id="story" className="py-20 sm:py-28 lg:py-36 px-4 sm:px-8 lg:px-16 bg-[#0C0C12] border-y border-[#242436]" data-testid="story-section">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <Reveal className="relative">
        <div className="clip-frame relative overflow-hidden border border-[#242436]" data-testid="founder-portrait-frame">
          <img src="/founder.webp" alt="Jeffery Mizell, Founder & CEO of G.A.M.E." className="w-full h-[420px] sm:h-[560px] object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#08080C] via-transparent to-transparent" />
          <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse 70% 60% at 50% 30%, transparent 40%, rgba(8,8,12,0.55) 100%)" }} />
          <div className="absolute bottom-5 left-5 bg-[#8B5CF6] text-black font-mono font-bold px-3 py-1 text-xs uppercase tracking-widest">
            Jeffery Mizell · Founder & CEO
          </div>
        </div>
        <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#8B5CF6] pointer-events-none" />
      </Reveal>

      <div>
        <Reveal>
          <div className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-[#FFB800] mb-4">Our Story</div>
          <h2 className="font-display font-black uppercase tracking-tight leading-none text-3xl sm:text-4xl lg:text-6xl text-[#F4F4F6]" data-testid="founder-name">
            Jeffery <span className="text-[#8B5CF6]">Mizell</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="mt-8 border-l-2 border-[#8B5CF6] pl-6 py-2">
            <Quote className="w-6 h-6 text-[#8B5CF6] mb-3" />
            <p className="font-display font-bold uppercase text-xl sm:text-2xl leading-snug text-[#F4F4F6]" data-testid="founder-quote">
              Our mission: empower youth through mentorship, academic enrichment, athletic
              development, health & wellness, and leadership training.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-sm sm:text-base leading-relaxed text-[#A1A1B3]" data-testid="founder-bio">
            G.A.M.E. Mentorship and Training Inc. — Grind. Achieve. Motivate. Excel. — is a
            youth-focused charitable organization founded by Jeffery Mizell. We provide young people,
            including those from underserved and economically challenged communities, with guidance,
            resources, and opportunities to build confidence, strengthen academic and athletic
            performance, and prepare for success in education, careers, and life.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
